import i18next, { ParseKeys } from 'i18next';

import en from './translations/en.json';

export const defaultNS = 'translations';
export const resources = {
    en: { Name: 'English', translations: en },
};

declare module 'i18next' {
    interface CustomTypeOptions {
        defaultNS: typeof defaultNS;
        resources: (typeof resources)['en'];
        returnNull: false;
    }
}

export type TranslationKeys = ParseKeys<'translations'>;
export const i18n = i18next;
